module.exports = __webpack_public_path__ + "img/hypervisor-2.6977b863.webp";